import { CoreEvent } from '@carvana/core-events';
import React, { useCallback, useEffect, useState } from 'react';
import { CancelOrderModal } from '|/app/navigation-rail/components/modals';
import {
  VERIFX_OPEN_CANCEL_ORDER_MODAL,
  coreEventOffWithType,
  type VerifxModalEvents
} from '|/app/verifx-events';

const CancelOrderModalListener: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handler = () => {
      setIsOpen(true);
    };
    CoreEvent.onWithType<VerifxModalEvents, typeof VERIFX_OPEN_CANCEL_ORDER_MODAL>(
      VERIFX_OPEN_CANCEL_ORDER_MODAL,
      handler
    );
    return () => {
      coreEventOffWithType<VerifxModalEvents, typeof VERIFX_OPEN_CANCEL_ORDER_MODAL>(
        VERIFX_OPEN_CANCEL_ORDER_MODAL,
        handler
      );
    };
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return <CancelOrderModal isOpen={isOpen} onClose={handleClose} />;
};

export default CancelOrderModalListener;
